export enum UserValueEnum {
  SUPPORT_CREDIT = "Кредитный специалист",
  AGENT_SIMPLE = "Агент",
  CLIENT_SIMPLE = "Клиент",
};
